import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "backupCameraFilled"
const BackupCameraFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.193 15.378C18.382 15.438 19.327 16.42 19.327 17.625 19.327 18.867 18.32 19.875 17.077 19.875S14.827 18.868 14.827 17.625 15.835 15.375 17.077 15.375zM3.697 6.697C3.989 6.404 4.464 6.404 4.757 6.697 5.05 6.989 5.05 7.464 4.757 7.757 4.2 8.314 3.76 8.976 3.457 9.704 3.156 10.432 3 11.212 3 12S3.155 13.568 3.457 14.296 4.2 15.686 4.757 16.243C5.05 16.536 5.05 17.01 4.757 17.303S3.99 17.597 3.697 17.304C3 16.607 2.447 15.78 2.07 14.87 1.694 13.96 1.5 12.985 1.5 12S1.694 10.04 2.07 9.13C2.448 8.22 3 7.393 3.698 6.697" />
          <path d="M22.5 5.063H19.695C19.012 5.063 18.36 5.349 17.898 5.853L15.528 8.438H22.5V17.438H20.447C20.35 15.66 18.878 14.25 17.077 14.25 15.277 14.25 13.805 15.66 13.707 17.438H10.5C9.775 17.438 9.188 16.85 9.188 16.125V13.313H10.5C10.81 13.313 11.063 13.06 11.063 12.75S10.81 12.188 10.5 12.188H9.188V10.875C9.188 9.529 10.278 8.438 11.625 8.438H14.002L17.068 5.092C17.743 4.356 18.696 3.938 19.695 3.938H22.5zM5.447 8.765C5.67 8.416 6.134 8.315 6.483 8.538 6.83 8.76 6.933 9.225 6.71 9.573 6.237 10.313 5.99 11.174 6 12.051S6.277 13.784 6.766 14.511C6.997 14.856 6.906 15.322 6.563 15.553S5.752 15.692 5.522 15.35C4.869 14.378 4.514 13.238 4.5 12.069 4.487 10.898 4.816 9.75 5.447 8.764" />
        </svg>
      }
    </span>
  )
}
export default BackupCameraFilledIcon
